import { toUpper } from 'lodash';

export const filterTravelAreas = (options, { inputValue }) => {
  const regex = new RegExp(inputValue.replace(/\\/g, '\\\\'), 'i');
  return options.filter((option) => {
    const { nameEN, nameHY, nameRU } = option.country || {};
    return regex.test(nameEN) || regex.test(nameHY) || regex.test(nameRU);
  });
};

export const filterOptions = (options, { inputValue }) => {
  const regex = new RegExp(inputValue.replace(/\\/g, '\\\\'), 'i');
  return options.filter((option) => {
    const { nameEN, nameHY, nameRU, name, code, label } = option || {};
    return (
      regex.test(nameEN)
      || regex.test(nameHY)
      || regex.test(nameRU)
      || regex.test(name)
      || regex.test(code)
      || regex.test(label)
    );
  });
};

export const getMenuLabelWithTranslation = (option, i18n) => option[`name${toUpper(i18n.language)}`];
